import { render, staticRenderFns } from "./newsBanner.vue?vue&type=template&id=7585551d&scoped=true"
import script from "./newsBanner.vue?vue&type=script&lang=js"
export * from "./newsBanner.vue?vue&type=script&lang=js"
import style1 from "./newsBanner.vue?vue&type=style&index=1&id=7585551d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7585551d",
  null
  
)

export default component.exports